module.exports = __webpack_public_path__ + "static/iris-ca47d633b52f7419814a955224504a0f.png";